"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generate = void 0;
const alphabets = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
function generate(length) {
    let code = '';
    for (let i = 0; i < length; i++) {
        const key = Math.floor(Math.random() * alphabets.length);
        code += alphabets[key];
    }
    return code;
}
exports.generate = generate;
exports.default = {
    generate,
};
//# sourceMappingURL=shortCode.js.map